import { FeatureSwitchRegistry } from "./generated";

export function getGeneratedFeatureSwitchVariants(switchName: string): string[] | undefined {
  const entry = (FeatureSwitchRegistry as Record<string, { variants: readonly string[] } | undefined>)[switchName];
  if (!entry) return undefined;
  return [...entry.variants];
}
